/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMaterialDto } from '../../models/backend-material-dto';
import { BackendPatchedMaterialRequestDto } from '../../models/backend-patched-material-request-dto';

export interface OpexesMaterialsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedMaterialRequestDto;
}

export function opexesMaterialsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesMaterialsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMaterialDto>> {
  const rb = new RequestBuilder(rootUrl, opexesMaterialsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMaterialDto>;
    }),
  );
}

opexesMaterialsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/opexes/materials/{id}/';
